import { ReactElement } from 'react'

import { useAuthContext } from 'context/AuthContext'
import { usePermissionsContext } from 'context/PermissionsContext'

type CanProps = {
  children: ReactElement
  permission?: string
  permissions?: string[]
  bypass?: boolean
}

const Can = ({ children, permission, permissions, bypass }: CanProps) => {
  const { user } = useAuthContext()
  const { hasPermission, hasAnyPermission } = usePermissionsContext()

  if (!user) return null

  if (bypass) return children

  if (permission) {
    return hasPermission(permission) ? children : null
  }

  if (permissions && permissions.length > 0) {
    return hasAnyPermission(permissions) ? children : null
  }

  return null
}

export default Can
